export const environment = {
  production: true,
  hmr: false,
  canonicalDomain: '{ BASE_TEMPLATE_CANONICAL_DOMAIN }',
};
